<template>
  <div class="row">
    <div class="col-md-8 col-sm-12">
      <breadcrumb :page="page" />
    </div>

    <div class="col">
      <div class="row">
        <div class="col-12">
          <div
            class="d-flex justify-content-end mt-0 mt-md-4 mt-sm-n2 mb-3 mb-md-0 mb-sm-3"
          >
            <ActionButton
              variant="outline-success mr-2"
              i="fas fa-arrow-circle-left"
              text="Regresar"
              @click="() => $router.back()"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="tag-badge-info">
        <span class="tag-badge-title-info pb-2 pl-3">
          {{ page.sections[0] }}
        </span>
      </div>
    </div>

    <div class="col-12">
      <DocumentManager
        :id="sie"
        :methods="methods"
        :comment-max-length="3000"
        :menu-actions="menuItems"
        :allowed-files="allowedFiles"
        :document-code-type="documentCodeType"
        :can-show-save="canShowSaveButton"
      />
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/common/page/TitleBreadcrumb';
import DocumentManager from '@/components/common/documents/Documents';
import store from '@/store/index';
import ActionButton from '@/components/common/ActionButton';

export default {
  name: 'Documents',
  components: {
    breadcrumb,
    DocumentManager,
    ActionButton,
  },

  data() {
    return {
      sie: store.getters['$_student/StudentSie'],
      page: {
        icon: 'fas fa-user-edit',
        title: 'Estudiante: Documentos',
        routes: ['Inicio', 'Estudiante', 'Documentos'],
        sections: ['Documentos del Estudiante'],
      },
      methods: {
        fetch: `api/student/attachments/${store.getters['$_student/StudentSie']}`,
        upload: `api/student/uploaddocument`,
        update: `api/student/updatedocument`,
        delete: `/api/student/deletedocument?id=`,
      },
      menuItems: [
        {
          iconClass: 'fas text-green fa-file-alt mr-1',
          method: 'downloadFile',
          text: 'Descargar',
        },
        {
          iconClass: 'fas text-green fa-pencil-alt mr-1',
          method: 'editFile',
          text: 'Editar',
        },
        {
          iconClass: 'fas text-red fa-times-circle mr-1',
          method: 'showConfirmationDelete',
          text: 'Eliminar',
          dataAttributes: {
            'data-toggle': 'modal',
            'data-target': '#popup',
          },
        },
      ],
      documentCodeType: 'EduEspStudentDocumentType',
      allowedFiles: '.pdf',
    };
  },
  computed: {
    canShowSaveButton() {
      return store.getters.HasPermission('student.documents.addbutton.view')
    },
  },
  methods: {},
};
</script>
